import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_CARRERAS = 'ALL_CARRERAS';
export const LOADING_ALL_CARRERAS = 'LOADING_ALL_CARRERAS';
export const ACTIVO_CARRERAS = 'ACTIVO_CARRERAS';
export const PARAMS_CARRERAS = 'PARAMS_CARRERAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const carrerasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_CARRERAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_CARRERAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_CARRERAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_CARRERAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
